<template>
  
  <div :id="_uid" class="ui small modal">
    <div class="ui header">
      Filtrar Laudos Pendentes
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Data Inicial</label>
            <date-picker ref="startDatePicker" :autoInit="false" @onChange="onChangeStartDate" />
          </div>         
          <div class="eight wide field">
            <label class="form-label">Data Final</label>
            <date-picker ref="endDatePicker" :autoInit="false" @onChange="onChangeEndDate" />
          </div>                                          
        </div>             
        <div class="fields">          
          <div class="eight wide field">
            <label class="form-label">Colaborador</label>
            <input v-model="filter.userName">
          </div>
          <div class="eight wide field">
            <label class="form-label">Clínica</label>
            <input v-model="filter.customerName">
          </div>          
        </div>
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Animal</label>
            <input v-model="filter.animalName">
          </div>
          <div class="eight wide field">
            <label class="form-label">Tutor</label>
            <input v-model="filter.ownerName">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>      
      <button v-if="showRemoveButton" class="ui teal basic button" @click="onRemove()">
        <i class="undo icon"></i> Remover
      </button>      
      <button class="ui blue button" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import modalDialog from "@/mixins/modal-dialog"
  import DatePicker from "@/components/date-picker"

  export default {
    
    name: "PendingCertsFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
        showRemoveButton: false,
      }
    },

    components: {
      DatePicker,
    },

    methods: {     
      
      onShow() {
        this.loading = true
        this.emitEvent = null
      },

      onVisible() {        
        
        this.initFilter()
        this.loadDatePickers()

        this.loading = false
      }, 

      initFilter() {

        this.$refs.startDatePicker.clearDate()
        this.$refs.endDatePicker.clearDate()

        if (this.$store.state.pages.filters.pendingCerts) {

          this.showRemoveButton = true
          this.filter = this.$cloneObject(this.$store.state.pages.filters.pendingCerts)

        } else {          

          this.showRemoveButton = false
          this.filter = { 
            startDate: null, 
            endDate: null, 
            userName: "",
            customerName: "",
            animalName: "",
            ownerName: "",
          }
        }   
        
        this.refreshData()
      },

      loadDatePickers() {
        
        this.$refs.startDatePicker.initCalendar({ force: true })
        this.$refs.endDatePicker.initCalendar({ force: true })        
        
        if (this.filter.startDate)
          this.$refs.startDatePicker.setDate(this.filter.startDate)
        
        if (this.filter.endDate)
          this.$refs.endDatePicker.setDate(this.filter.endDate)        
      },  

      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()          
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {

        this.updateStore(this.filter)

        let data = this.$cloneObject(this.filter)

        if (data.startDate)
          data.startDate = moment(data.startDate).format("YYYY-MM-DD")

        if (data.endDate)  
          data.endDate = moment(data.endDate).format("YYYY-MM-DD")
        
        this.emitEvent = { event: "onApply", data }

        this.hide()        
      },

      updateStore(filter) {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.pendingCerts = filter ? this.$cloneObject(filter) : null

        this.$store.commit("pages/setFilters", filters)
      },

      onRemove() {

        this.clear()

        this.emitEvent = { event: "onRemove" }

        this.hide()      
      },

      clear() {
        this.updateStore(null)
      },
    },
  }

</script>